import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["file", "gatsbyFile", "description", "altText"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _has from 'lodash/has';
import _omit from 'lodash/omit';
export function businessFileToImageProps(images) {
  return (images || []).map(function (image) {
    var file = image.file,
      gatsbyFile = image.gatsbyFile,
      description = image.description,
      altText = image.altText,
      restFile = _objectWithoutProperties(image, _excluded);
    var baseImage = _objectSpread(_objectSpread({}, restFile), {}, {
      altText: altText || description || ''
    });
    if (gatsbyFile) {
      return _objectSpread(_objectSpread({}, baseImage), {}, {
        src: gatsbyFile.childImageSharp
      });
    }
    return _objectSpread(_objectSpread({}, baseImage), {}, {
      src: file
    });
  });
}
export function getGatsbyImageStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parentStyles = {};
  var childStyles = _objectSpread({}, style);
  function moveStyleToParent(styleName) {
    if (_has(style, styleName)) {
      childStyles = _omit(childStyles, styleName);
      parentStyles = _objectSpread(_objectSpread({}, parentStyles), {}, _defineProperty({}, styleName, style[styleName]));
    }
  }
  moveStyleToParent('boxShadow');
  moveStyleToParent('border');
  moveStyleToParent('borderRadius');
  moveStyleToParent('width');
  moveStyleToParent('height');
  moveStyleToParent('minHeight');
  moveStyleToParent('maxHeight');
  moveStyleToParent('maxWidth');
  moveStyleToParent('minWidth');
  moveStyleToParent('margin');
  return {
    parentStyles: parentStyles,
    childStyles: childStyles
  };
}